import {
    getRedirectURL,
    urlEncodedParams,
    getOauthClientID,
    getStore,
} from "../../factory";
import { outlookOauthSettings } from "../../../api/endpoints";

// const SCOPE = 'https://graph.microsoft.com/calendars.readwrite';
const SCOPE = 'https%3A%2F%2Fgraph.microsoft.com%2Fcalendars.readwrite%20offline_access';

/*
export const windowsLiveOauthUrl = ({
  callbackUrl,
  clientId,
  state,
}) => (`https://login.microsoftonline.com/common/oauth2/v2.0/authorize
  ?response_type=code
  &redirect_uri=${encodeURIComponent(callbackUrl)}
  &client_id=${encodeURIComponent(clientId)}
  &scope=https%3A%2F%2Fgraph.microsoft.com%2Fcalendars.readwrite%20offline_access
  &state=${encodeURIComponent(JSON.stringify(state))}`.replace(/\s/g, '')
);
*/


// CALLBACK:   https://oauth.ecal.com/auth/outlook/oauth2callback
function generateParams (params) {
    let state =  {
        locale: params.locale,
        apiKey: params.apiKey,
        sessionId: params.oauthSessionId,
        browser: params.browser,
        calendarApp: params.calendar,
    };

    if (params.state) {
        state = params.state;
    }

    
    return {
        response_type: 'code',
        redirect_uri: `https://${getRedirectURL()}/auth/outlook/oauth2callback`,
        client_id: getOauthClientID(outlookOauthSettings, params),
        scope: SCOPE,
        state,
    };
}

// could open on a separate window to make an oauth call
function outlookOAuthAPI (params) {
    const appStore = getStore('appStore');
    const flags = appStore.flags;
    const p = generateParams(params);
    console.log('outlookOAuthAPI() p: ', p);
    let url = `${outlookOauthSettings.OAUTH_URL}${urlEncodedParams(p)}`;
    
    console.log('outlookOAuthAPI() URL: ', url);
    if (!flags.inAppBrowser) {
        window.open(url, '_self');
    } else {
        const appClient = getStore('appClientStore');
        appClient.locationAssign(url);
    }
}

export default outlookOAuthAPI;
